import { useEffect, useMemo } from "react";
import { projectIdState } from "atoms/atoms-admin";
import { selectedInstanceState } from "atoms/atoms-content";
import { useRecoilValue, useRecoilState } from "recoil";
import CustomTable from "components/elements/CustomTableDivStyled";
import { BrmMainTable } from "brm/tables/BrmTables";
import PropTypes from "prop-types";
import useRefreshTableList from "hooks/useRefreshTableList";
import { TYPE } from "constants/brm";
import * as TrevApi from "brm/risk-model/trev/api";
import { ErrorBanner, LoadingSpinner as Loading } from "components/elements";
import { createColumnCategoryName } from "brm/tables/services/column/columnFactory";
import { useRoles } from "features/brm";

const ThreatEventPatternTable = ({ setSelectedRows, refresh, setRefresh }) => {
  const { isRiskAnalyst } = useRoles();
  const projectId = useRecoilValue(projectIdState);
  const [selectedInstance, setSelectedInstance] = useRecoilState(selectedInstanceState);
  const { data: trevPatterns, isError } = TrevApi.useGetThreatEventPatterns(projectId, {
    enabled: !!projectId && isRiskAnalyst,
  });

  const columns = useMemo(
    () => [createColumnCategoryName(selectedInstance.id, setSelectedInstance, "threatEventPattern")],
    [selectedInstance.id, setSelectedInstance]
  );

  // Refresh the table list if project selection changes
  useRefreshTableList(projectId, setRefresh);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh, setRefresh]);

  if (isError) {
    return <ErrorBanner msg="Error while loading Threat Event Pattern data" />;
  }

  if (trevPatterns) {
    return (
      <>
        <CustomTable>
          <BrmMainTable
            data={trevPatterns}
            columns={columns}
            setSelectedRows={setSelectedRows}
            customProps={{ id: "ThreatEventPatternTable_table" }}
            showRowSelect={false}
            elementName={TYPE.trevPat}
          />
        </CustomTable>
      </>
    );
  }
  return <Loading />;
};

ThreatEventPatternTable.propTypes = {
  setSelectedRows: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default ThreatEventPatternTable;
